// Essence collection: chips filter cards by product type or by sale tier (e.g. "50%"); photo breaks hide while filtering; a colour swatch swaps the card image and links to that variant.
(function () {
  document.addEventListener('click', function (event) {
    var chip = event.target.closest('.essence__chip[data-filter]');
    if (chip) {
      var root = chip.closest('[data-essence-collection]');
      var types = chip.dataset.filter ? chip.dataset.filter.split(',') : [];

      root.querySelectorAll('.essence__chip').forEach(function (el) {
        el.classList.toggle('is-active', el === chip);
        el.setAttribute('aria-pressed', el === chip ? 'true' : 'false');
      });
      root.querySelectorAll('[data-essence-card]').forEach(function (card) {
        var match = types.indexOf(card.dataset.type) !== -1 || (card.dataset.tier && types.indexOf(card.dataset.tier) !== -1);
        card.hidden = types.length > 0 && !match;
      });
      root.querySelectorAll('[data-essence-break]').forEach(function (el) {
        el.hidden = types.length > 0;
      });
      return;
    }

    var swatch = event.target.closest('[data-swatch]');
    if (!swatch) return;

    var card = swatch.closest('[data-essence-card]');
    if (!card) return;

    card.querySelectorAll('[data-swatch]').forEach(function (el) {
      el.classList.toggle('is-selected', el === swatch);
      el.setAttribute('aria-pressed', el === swatch ? 'true' : 'false');
    });

    var img = card.querySelector('.essence-card__media img');
    if (img && swatch.dataset.src) {
      img.src = swatch.dataset.src;
      if (swatch.dataset.srcset) img.srcset = swatch.dataset.srcset;
    }

    var title = card.querySelector('[data-card-title]');
    if (title && swatch.dataset.title) title.textContent = swatch.dataset.title;

    if (swatch.dataset.url) {
      card.querySelectorAll('[data-card-link]').forEach(function (link) {
        link.href = swatch.dataset.url;
      });
    }
  });
})();